import i18n from "i18next";
import {
  Dropdown,
  Field,
  Input,
  Option,
  Combobox,
} from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";

interface IEditProfileProps {
  accountValues: IAppUserDto;
  accountValuesChanged(item: boolean): void;
  onAccountValuesChange(item: IAppUserDto): void;
  saveDisabled(item: boolean): void;
  branchen: { key: string; text: string }[];
  onBranchenChange(
    item: { key: string; selected: boolean; text: string } | undefined,
  ): void;
  selectedBranchenKeys: string[];
  arbeitsgebiete: { key: string; text: string }[];
  onArbeitsgebieteChange(
    item: { key: string; selected: boolean; text: string } | undefined,
  ): void;
  selectedArbeitsgebieteKeys: string[];
}

function EditProfile(props: IEditProfileProps) {
  const windowSize = useWindowSize();
  const anredeDE = [
    { key: "Herr", text: "Herr" },
    { key: "Frau", text: "Frau" },
  ];

  const anredeEN = [
    { key: "Herr", text: "Mr" },
    { key: "Frau", text: "Mrs" },
  ];
  const [countries, setCountries] = useState<{ key: string; text: string }[]>(
    [],
  );
  const [branchen, setBranchen] = useState<{ key: string; text: string }[]>([]);
  const [arbeitsgebiete, setArbeitsgebiete] = useState<
    { key: string; text: string }[]
  >([]);
  const [selectedBranchenString, setSelectedBranchenString] =
    useState<string>();
  const [selectedArbeitsgebieteString, setSelectedArbeitsgebieteString] =
    useState<string>();

  const [accountValues, setAccountValues] = useState(props.accountValues);
  const handleAccountValuesChange = (name: string, val: any) => {
    setAccountValues((prevState: IAppUserDto) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const currentCountry: { key: string; text: string } | undefined =
    countries.find((x) => x.key == accountValues.landGuid);

  const getCountries = () => {
    fetchWrapper.get(`${baseUrl}/api/account/getcountries`).then((result) => {
      let options: { key: string; text: string }[] = [];
      result.forEach((element: any) => {
        let option: { key: string; text: string } = {
          key: element.landGuid,
          text: i18n.language.includes("de")
            ? element.name_DE
            : element.name_EN,
        };
        options.push(option);
      });
      options.sort((a, b) => a.text.localeCompare(b.text));
      setCountries(options);
    });
  };

  useEffect(() => {
    if (accountValues != undefined) {
      props.onAccountValuesChange(accountValues);
      props.accountValuesChanged(false);
    }
  }, [accountValues]);
  useEffect(() => {
    setAccountValues(accountValues);
  }, [props.accountValues]);

  useEffect(() => {
    getCountries();
    props.accountValuesChanged(true);
  }, []);

  useEffect(() => {
    setBranchen(props.branchen);
  }, [props.branchen]);
  useEffect(() => {
    let tempString: string = "";
    props.branchen.forEach((item) => {
      if (props.selectedBranchenKeys.includes(item.key)) {
        if (tempString == "") {
          tempString = tempString + item.text;
        } else {
          tempString = tempString + ", " + item.text;
        }
      }
    });
    setSelectedBranchenString(tempString);
  }, [props.selectedBranchenKeys]);

  useEffect(() => {
    setArbeitsgebiete(props.arbeitsgebiete);
  }, [props.arbeitsgebiete]);
  useEffect(() => {
    let tempString: string = "";
    props.arbeitsgebiete.forEach((item) => {
      if (props.selectedArbeitsgebieteKeys.includes(item.key)) {
        if (tempString == "") {
          tempString = tempString + item.text;
        } else {
          tempString = tempString + ", " + item.text;
        }
      }
    });
    setSelectedArbeitsgebieteString(tempString);
  }, [props.selectedArbeitsgebieteKeys]);

  return (
    <>
      <Field label={i18n.t<string>("anrede") + " / " + i18n.t<string>("title")}>
        <Dropdown
          value={accountValues.anrede}
          defaultSelectedOptions={[accountValues.anrede]}
          onOptionSelect={(ev, data) => {
            handleAccountValuesChange("anrede", data.optionValue);
          }}
        >
          {i18n.language.includes("de") &&
            anredeDE.map((item) => {
              return (
                <Option
                  value={item.text}
                  onClick={() => {
                    handleAccountValuesChange("anrede", item.text);
                  }}
                >
                  {item.text}
                </Option>
              );
            })}
          {i18n.language.includes("en") &&
            anredeEN.map((item) => {
              return (
                <Option
                  value={item.text}
                  onClick={() => {
                    handleAccountValuesChange("anrede", item.text);
                  }}
                >
                  {item.text}
                </Option>
              );
            })}
        </Dropdown>
      </Field>
      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 475 ? "column" : "row",
        }}
      >
        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingRight: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          label={i18n.t<string>("firstName")}
          required
          validationMessage={
            accountValues.vorname ? "" : i18n.t<string>("informationRequired")
          }
        >
          <Input
            placeholder={i18n.t<string>("firstName")}
            value={accountValues.vorname}
            onChange={(ev, newText) => {
              handleAccountValuesChange("vorname", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>

        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingLeft: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          label={i18n.t<string>("lastName")}
          required
          validationMessage={
            accountValues.nachname ? "" : i18n.t<string>("informationRequired")
          }
        >
          <Input
            placeholder={i18n.t<string>("lastName")}
            onChange={(ev, newText) => {
              handleAccountValuesChange("nachname", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
            value={accountValues.nachname}
          />
        </Field>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 475 ? "column" : "row",
        }}
      >
        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingRight: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          required
          validationMessage={
            accountValues.firma ? "" : i18n.t<string>("informationRequired")
          }
          label={i18n.t<string>("company")}
        >
          <Input
            placeholder={i18n.t<string>("company")}
            value={accountValues.firma}
            onChange={(ev, newText) => {
              handleAccountValuesChange("firma", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>

        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingLeft: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          label={i18n.t<string>("department")}
        >
          <Input
            placeholder={i18n.t<string>("department")}
            value={accountValues.abteilung}
            onChange={(ev, newText) => {
              handleAccountValuesChange("abteilung", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 475 ? "column" : "row",
        }}
      >
        <Field
          label={i18n.t<string>("website")}
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingRight: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
        >
          <Input
            contentBefore="https://"
            placeholder={i18n.t<string>("website")}
            value={accountValues.webseite}
            onChange={(ev, newText) =>
              handleAccountValuesChange("webseite", newText.value)
            }
          />
        </Field>

        <Field
          label={i18n.t<string>("telephone")}
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingLeft: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
        >
          <Input
            placeholder={i18n.t<string>("telephone")}
            value={accountValues.telefonNummer}
            onChange={(ev, newText) => {
              handleAccountValuesChange("telefonNummer", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>
      </div>

      <Field
        style={{ width: "100%" }}
        required
        validationMessage={
          accountValues.landGuid ? "" : i18n.t<string>("informationRequired")
        }
        label={i18n.t<string>("country")}
      >
        <Dropdown
          onOptionSelect={(ev, val) => {
            handleAccountValuesChange("landGuid", val.optionValue);
          }}
          value={currentCountry?.text ? currentCountry.text : ""}
        >
          {countries.map((item) => {
            return <Option value={item.key}>{item.text}</Option>;
          })}
        </Dropdown>
      </Field>

      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 475 ? "column" : "row",
        }}
      >
        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingRight: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          required
          validationMessage={
            accountValues.postleitzahl
              ? ""
              : i18n.t<string>("informationRequired")
          }
          label={i18n.t<string>("zip")}
        >
          <Input
            placeholder={i18n.t<string>("zip")}
            value={accountValues.postleitzahl}
            onChange={(ev, newText) => {
              handleAccountValuesChange("postleitzahl", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>

        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingLeft: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          required
          validationMessage={
            accountValues.stadt ? "" : i18n.t<string>("informationRequired")
          }
          label={i18n.t<string>("city")}
        >
          <Input
            placeholder={i18n.t<string>("city")}
            value={accountValues.stadt}
            onChange={(ev, newText) => {
              handleAccountValuesChange("stadt", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 475 ? "column" : "row",
        }}
      >
        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingRight: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          required
          validationMessage={
            accountValues.strasse ? "" : i18n.t<string>("informationRequired")
          }
          label={i18n.t<string>("street")}
        >
          <Input
            placeholder={i18n.t<string>("street")}
            value={accountValues.strasse}
            onChange={(ev, newText) => {
              handleAccountValuesChange("strasse", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>

        <Field
          style={{
            width: windowSize.width < 475 ? "100%" : "50%",
            paddingLeft: windowSize.width < 475 ? "" : "10px",
            marginTop: "10px",
          }}
          required
          validationMessage={
            accountValues.hausnummer
              ? ""
              : i18n.t<string>("informationRequired")
          }
          label={i18n.t<string>("houseNo")}
        >
          <Input
            placeholder={i18n.t<string>("houseNo")}
            value={accountValues.hausnummer}
            onChange={(ev, newText) => {
              handleAccountValuesChange("hausnummer", newText.value);
              if (newText.value == "") {
                props.saveDisabled(true);
              } else props.saveDisabled(false);
            }}
          />
        </Field>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: windowSize.width < 770 ? "column" : "row",
        }}
      >
        <Field
          label={i18n.t<string>("branchen")}
          style={{
            width: windowSize.width < 770 ? "100%" : "50%",
            paddingRight: windowSize.width < 770 ? "" : "10px",
            marginTop: "10px",
          }}
        >
          <Dropdown
            placeholder={i18n.t<string>("branchen")}
            onOptionSelect={(ev, val) => {
              if (val.optionValue)
                props.onBranchenChange({
                  text: val.optionText ? val.optionText : "",
                  key: val.optionValue ? val.optionValue : "",
                  selected: val.selectedOptions.includes(val.optionValue),
                });
            }}
            multiselect
            value={selectedBranchenString}
            selectedOptions={props.selectedBranchenKeys}
          >
            {branchen.map((item) => {
              return <Option value={item.key}>{item.text}</Option>;
            })}
          </Dropdown>
        </Field>

        <Field
          label={i18n.t<string>("arbeitsgebiete")}
          style={{
            width: windowSize.width < 770 ? "100%" : "50%",
            paddingLeft: windowSize.width < 770 ? "" : "10px",
            marginTop: "10px",
          }}
        >
          <Dropdown
            placeholder={i18n.t<string>("arbeitsgebiete")}
            onOptionSelect={(ev, val) => {
              if (val.optionValue)
                props.onArbeitsgebieteChange({
                  text: val.optionText ? val.optionText : "",
                  key: val.optionValue ? val.optionValue : "",
                  selected: val.selectedOptions.includes(val.optionValue),
                });
            }}
            multiselect
            value={selectedArbeitsgebieteString}
            selectedOptions={props.selectedArbeitsgebieteKeys}
          >
            {arbeitsgebiete.map((item) => {
              return <Option value={item.key}>{item.text}</Option>;
            })}
          </Dropdown>
        </Field>
      </div>
    </>
  );
}
export default EditProfile;
